"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScript = void 0;
var _react = require("react");
// Loads external scripts; alternative to using Helmet.
// Helmet was buggy when loading ScheduleOnce widgets
// (one for each clinician) in the dashboard - it would
// not work unless a page refresh was done.
var useScript = function useScript(url, id) {
  (0, _react.useEffect)(function () {
    var script = document.createElement('script');
    script.src = url;
    script.id = id;
    script.async = true;
    document.body.appendChild(script);
    return function () {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
};
exports.useScript = useScript;